export default __webpack_public_path__ + "static/sanlingxiaobus-781e71c62c2f5eb118cfcbaa69b9e660.png";